export const PATIENT_CURRENT_REPORT_OPTIONS = {
  APPOINTMENT_DATE_TIME: "Patient.CurrentReport.AppointmentDateTime",
  APPOINTMENT_TYPE: "Patient.CurrentReport.AppointmentType",
  LEFT_HEARING_LOSS: "Patient.CurrentReport.LeftHearingLoss",
  RIGHT_HEARING_LOSS: "Patient.CurrentReport.RightHearingLoss",
  LEFT_WRS_PRESENTATION_LEVEL_LOSS:
    "Patient.CurrentReport.LeftWRSAndPresentationLevel",
  RIGHT_WRS_PRESENTATION_LEVEL_LOSS:
    "Patient.CurrentReport.RightWRSAndPresentationLevel",
  LEFT_QUICKSIN_AND_SNR_LOSS: "Patient.CurrentReport.LeftQuickSinAndSnrLoss",
  RIGHT_QUICKSIN_AND_SNR_LOSS: "Patient.CurrentReport.RightQuickSinAndSnrLoss",
  BINAURAL_QUICKSIN_AND_SNR_LOSS:
    "Patient.CurrentReport.BinauralQuickSinAndSnrLoss",
  LEFT_TYMPANOGRAM_TYPE: "Patient.CurrentReport.LeftTympanogramType",
  RIGHT_TYMPANOGRAM_TYPE: "Patient.CurrentReport.RightTympanogramType",
  LEFT_HEARING_LOSS_LEVEL: "Patient.CurrentReport.LeftHearingLossLevel",
  RIGHT_HEARING_LOSS_LEVEL: "Patient.CurrentReport.RightHearingLossLevel",
  LEFT_HEARING_LOSS_SHAPE: "Patient.CurrentReport.LeftHearingLossShape",
  RIGHT_HEARING_LOSS_SHAPE: "Patient.CurrentReport.RightHearingLossShape",
  LEFT_HEARING_LOSS_TYPE: "Patient.CurrentReport.LeftHearingLossType",
  RIGHT_HEARING_LOSS_TYPE: "Patient.CurrentReport.RightHearingLossType",
  LEFT_AIR_CONDUCTION_THRESHOLDS:
    "Patient.CurrentReport.LeftAirConductionThresholds",
  RIGHT_AIR_CONDUCTION_THRESHOLDS:
    "Patient.CurrentReport.RightAirConductionThresholds",
  LEFT_BONE_CONDUCTION_THRESHOLDS:
    "Patient.CurrentReport.LeftBoneConductionThresholds",
  RIGHT_BONE_CONDUCTION_THRESHOLDS:
    "Patient.CurrentReport.RightBoneConductionThresholds",
  LEFT_PTA: "Patient.CurrentReport.LeftPta",
  RIGHT_PTA: "Patient.CurrentReport.RightPta",
  LEFT_SRT: "Patient.CurrentReport.LeftSrt",
  RIGHT_SRT: "Patient.CurrentReport.RightSrt",
  LEFT_SRT_MASKING: "Patient.CurrentReport.LeftSrtMasking",
  RIGHT_SRT_MASKING: "Patient.CurrentReport.RightSrtMasking",
  LEFT_WRS_MASKING: "Patient.CurrentReport.LeftWrsMasking",
  RIGHT_WRS_MASKING: "Patient.CurrentReport.RightWrsMasking",
  LEFT_TYMPANOMETRY_ADMITTANCE:
    "Patient.CurrentReport.LeftTympanometryAdmittance",
  RIGHT_TYMPANOMETRY_ADMITTANCE:
    "Patient.CurrentReport.RightTympanometryAdmittance",
  LEFT_TYMPANOMETRY_ECV: "Patient.CurrentReport.LeftTympanometryEcv",
  RIGHT_TYMPANOMETRY_ECV: "Patient.CurrentReport.RightTympanometryEcv",
  LEFT_TYMPANOMETRY_PRESSURE: "Patient.CurrentReport.LeftTympanometryPressure",
  RIGHT_TYMPANOMETRY_PRESSURE:
    "Patient.CurrentReport.RightTympanometryPressure",
  LEFT_ACOUSTIC_REFLEX_THRESHOLDS:
    "Patient.CurrentReport.LeftAcousticReflexThresholds",
  RIGHT_ACOUSTIC_REFLEX_THRESHOLDS:
    "Patient.CurrentReport.RightAcousticReflexThresholds",
  LEFT_ACOUSTIC_REFLEX_DECAY: "Patient.CurrentReport.LeftAcousticReflexDecay",
  RIGHT_ACOUSTIC_REFLEX_DECAY: "Patient.CurrentReport.RightAcousticReflexDecay",
  LEFT_QUICKSIN_METHOD: "Patient.CurrentReport.LeftQuickSinMethod",
  RIGHT_QUICKSIN_METHOD: "Patient.CurrentReport.RightQuickSinMethod",
  LEFT_OAE_TYPE: "Patient.CurrentReport.LeftOaeType",
  RIGHT_OAE_TYPE: "Patient.CurrentReport.RightOaeType",
  LEFT_OAE_RESULTS: "Patient.CurrentReport.LeftOaeResults",
  RIGHT_OAE_RESULTS: "Patient.CurrentReport.RightOaeResults",
  ICD10_CODES: "Patient.CurrentReport.Icd10Codes",
  CUSTOM_TESTS: "Patient.CurrentReport.CustomTests",
  FULL_AUDIOGRAM: "Patient.CurrentReport.FullAudiogram",
  SUMMARY: "Patient.CurrentReport.Summary"
};

const leftEarMenu = [
  {
    title: "Patient - Current Report - Left Hearing Loss",
    value: PATIENT_CURRENT_REPORT_OPTIONS.LEFT_HEARING_LOSS
  },
  {
    title: "Patient - Current Report - Left WRS and Presentation Level",
    value: PATIENT_CURRENT_REPORT_OPTIONS.LEFT_WRS_PRESENTATION_LEVEL_LOSS
  },
  {
    title: "Patient - Current Report - Left QuickSIN and SNR Loss",
    value: PATIENT_CURRENT_REPORT_OPTIONS.LEFT_QUICKSIN_AND_SNR_LOSS
  },
  {
    title: "Patient - Current Report - Left Tympanogram Type",
    value: PATIENT_CURRENT_REPORT_OPTIONS.LEFT_TYMPANOGRAM_TYPE
  },
  {
    title: "Patient - Current Report - Left Hearing Loss Level",
    value: PATIENT_CURRENT_REPORT_OPTIONS.LEFT_HEARING_LOSS_LEVEL
  },
  {
    title: "Patient - Current Report - Left Hearing Loss Shape",
    value: PATIENT_CURRENT_REPORT_OPTIONS.LEFT_HEARING_LOSS_SHAPE
  },
  {
    title: "Patient - Current Report - Left Hearing Loss Type",
    value: PATIENT_CURRENT_REPORT_OPTIONS.LEFT_HEARING_LOSS_TYPE
  },
  {
    title: "Patient - Current Report - Left Air Conduction Thresholds",
    value: PATIENT_CURRENT_REPORT_OPTIONS.LEFT_AIR_CONDUCTION_THRESHOLDS
  },
  {
    title: "Patient - Current Report - Left Bone Conduction Thresholds",
    value: PATIENT_CURRENT_REPORT_OPTIONS.LEFT_BONE_CONDUCTION_THRESHOLDS
  },
  {
    title: "Patient - Current Report - Left PTA",
    value: PATIENT_CURRENT_REPORT_OPTIONS.LEFT_PTA
  },
  {
    title: "Patient - Current Report - Left SRT",
    value: PATIENT_CURRENT_REPORT_OPTIONS.LEFT_SRT
  },
  {
    title: "Patient - Current Report - Left SRT Masking",
    value: PATIENT_CURRENT_REPORT_OPTIONS.LEFT_SRT_MASKING
  },
  {
    title: "Patient - Current Report - Left WRS Masking",
    value: PATIENT_CURRENT_REPORT_OPTIONS.LEFT_WRS_MASKING
  },
  {
    title: "Patient - Current Report - Left Tympanometry Admittance",
    value: PATIENT_CURRENT_REPORT_OPTIONS.LEFT_TYMPANOMETRY_ADMITTANCE
  },
  {
    title: "Patient - Current Report - Left Tympanometry ECV",
    value: PATIENT_CURRENT_REPORT_OPTIONS.LEFT_TYMPANOMETRY_ECV
  },
  {
    title: "Patient - Current Report - Left Tympanometry Pressure",
    value: PATIENT_CURRENT_REPORT_OPTIONS.LEFT_TYMPANOMETRY_PRESSURE
  },
  {
    title: "Patient - Current Report - Left Acoustic Reflex Thresholds",
    value: PATIENT_CURRENT_REPORT_OPTIONS.LEFT_ACOUSTIC_REFLEX_THRESHOLDS
  },
  {
    title: "Patient - Current Report - Left Acoustic Reflex Decay",
    value: PATIENT_CURRENT_REPORT_OPTIONS.LEFT_ACOUSTIC_REFLEX_DECAY
  },
  {
    title: "Patient - Current Report - Left QuickSIN Method",
    value: PATIENT_CURRENT_REPORT_OPTIONS.LEFT_QUICKSIN_METHOD
  },
  {
    title: "Patient - Current Report - Left OAE Type",
    value: PATIENT_CURRENT_REPORT_OPTIONS.LEFT_OAE_TYPE
  },
  {
    title: "Patient - Current Report - Left OAE Results",
    value: PATIENT_CURRENT_REPORT_OPTIONS.LEFT_OAE_RESULTS
  }
];

const rightEarMenu = [
  {
    title: "Patient - Current Report - Right Hearing Loss",
    value: PATIENT_CURRENT_REPORT_OPTIONS.RIGHT_HEARING_LOSS
  },
  {
    title: "Patient - Current Report - Right WRS and Presentation Level",
    value: PATIENT_CURRENT_REPORT_OPTIONS.RIGHT_WRS_PRESENTATION_LEVEL_LOSS
  },
  {
    title: "Patient - Current Report - Right QuickSIN and SNR Loss",
    value: PATIENT_CURRENT_REPORT_OPTIONS.RIGHT_QUICKSIN_AND_SNR_LOSS
  },
  {
    title: "Patient - Current Report - Right Tympanogram Type",
    value: PATIENT_CURRENT_REPORT_OPTIONS.RIGHT_TYMPANOGRAM_TYPE
  },
  {
    title: "Patient - Current Report - Right Hearing Loss Level",
    value: PATIENT_CURRENT_REPORT_OPTIONS.RIGHT_HEARING_LOSS_LEVEL
  },
  {
    title: "Patient - Current Report - Right Hearing Loss Shape",
    value: PATIENT_CURRENT_REPORT_OPTIONS.RIGHT_HEARING_LOSS_SHAPE
  },
  {
    title: "Patient - Current Report - Right Hearing Loss Type",
    value: PATIENT_CURRENT_REPORT_OPTIONS.RIGHT_HEARING_LOSS_TYPE
  },
  {
    title: "Patient - Current Report - Right Air Conduction Thresholds",
    value: PATIENT_CURRENT_REPORT_OPTIONS.RIGHT_AIR_CONDUCTION_THRESHOLDS
  },
  {
    title: "Patient - Current Report - Right Bone Conduction Thresholds",
    value: PATIENT_CURRENT_REPORT_OPTIONS.RIGHT_BONE_CONDUCTION_THRESHOLDS
  },
  {
    title: "Patient - Current Report - Right PTA",
    value: PATIENT_CURRENT_REPORT_OPTIONS.RIGHT_PTA
  },
  {
    title: "Patient - Current Report - Right SRT",
    value: PATIENT_CURRENT_REPORT_OPTIONS.RIGHT_SRT
  },
  {
    title: "Patient - Current Report - Right SRT Masking",
    value: PATIENT_CURRENT_REPORT_OPTIONS.RIGHT_SRT_MASKING
  },
  {
    title: "Patient - Current Report - Right WRS Masking",
    value: PATIENT_CURRENT_REPORT_OPTIONS.RIGHT_WRS_MASKING
  },
  {
    title: "Patient - Current Report - Right Tympanometry Admittance",
    value: PATIENT_CURRENT_REPORT_OPTIONS.RIGHT_TYMPANOMETRY_ADMITTANCE
  },
  {
    title: "Patient - Current Report - Right Tympanometry ECV",
    value: PATIENT_CURRENT_REPORT_OPTIONS.RIGHT_TYMPANOMETRY_ECV
  },
  {
    title: "Patient - Current Report - Right Tympanometry Pressure",
    value: PATIENT_CURRENT_REPORT_OPTIONS.RIGHT_TYMPANOMETRY_PRESSURE
  },
  {
    title: "Patient - Current Report - Right Acoustic Reflex Thresholds",
    value: PATIENT_CURRENT_REPORT_OPTIONS.RIGHT_ACOUSTIC_REFLEX_THRESHOLDS
  },
  {
    title: "Patient - Current Report - Right Acoustic Reflex Decay",
    value: PATIENT_CURRENT_REPORT_OPTIONS.RIGHT_ACOUSTIC_REFLEX_DECAY
  },
  {
    title: "Patient - Current Report - Right QuickSIN Method",
    value: PATIENT_CURRENT_REPORT_OPTIONS.RIGHT_QUICKSIN_METHOD
  },
  {
    title: "Patient - Current Report - Right OAE Type",
    value: PATIENT_CURRENT_REPORT_OPTIONS.RIGHT_OAE_TYPE
  },
  {
    title: "Patient - Current Report - Right OAE Results",
    value: PATIENT_CURRENT_REPORT_OPTIONS.RIGHT_OAE_RESULTS
  }
];

export const PATIENT_CURRENT_REPORT_MENU_OPTIONS = {
  title: "Patient - Current Report",
  menu: [
    {
      title: "Patient - Current Report - Appointment Date Time",
      value: PATIENT_CURRENT_REPORT_OPTIONS.APPOINTMENT_DATE_TIME
    },
    {
      title: "Patient - Current Report - Appointment Type",
      value: PATIENT_CURRENT_REPORT_OPTIONS.APPOINTMENT_TYPE
    },
    {
      title: "Patient - Current Report - Left Ear",
      menu: leftEarMenu
    },
    {
      title: "Patient - Current Report - Right Ear",
      menu: rightEarMenu
    },
    {
      title: "Patient - Current Report - Binaural QuickSIN and SNR Loss",
      value: PATIENT_CURRENT_REPORT_OPTIONS.BINAURAL_QUICKSIN_AND_SNR_LOSS
    },
    {
      title: "Patient - Current Report - ICD-10 Codes",
      value: PATIENT_CURRENT_REPORT_OPTIONS.ICD10_CODES
    },
    {
      title: "Patient - Current Report - Custom Tests",
      value: PATIENT_CURRENT_REPORT_OPTIONS.CUSTOM_TESTS
    },
    {
      title: "Patient - Current Report - Full Audiogram",
      value: PATIENT_CURRENT_REPORT_OPTIONS.FULL_AUDIOGRAM
    },
    {
      title: "Patient - Current Report - Summary",
      value: PATIENT_CURRENT_REPORT_OPTIONS.SUMMARY
    }
  ]
};
